import {
  CMS_API_BASE_URL,
  SEO_PAGES_QUERY_ID,
  SEO_PAGES_V2_QUERY_ID,
} from "@tm/api-utils";
import { PARTNER } from "@tm/isomorphic-utils";
import { API_HTTP } from "../apiInstance";

export const getSeoLandingPageDetailsByCountryForPwa = async (
  countryId: string,
  partner: "gi" | "mmt"
) => {
  try {
    const response = await fetch(
      `${CMS_API_BASE_URL}/api/v1/seo/jsons?type=${
        partner === PARTNER.GI
          ? SEO_PAGES_QUERY_ID.LANDING_PAGE_COUNTRY_GI
          : SEO_PAGES_QUERY_ID.LANDING_PAGE_COUNTRY
      },seo-insurance${
        partner === PARTNER.GI ? `-${partner}` : ""
      }-landing-${countryId}`
    );
    if (response.status !== 200) {
      throw new Error(
        `Error fetching data for SEO landing page for ${countryId}`
      );
    }
    const json = await response.json();
    return json;
  } catch (error) {
    console.error(`Error fetching data for SEO landing page for ${countryId}`, {
      error,
    });
    throw error;
  }
};

export const getSeoLandingPageDetailsByCountry = async (
  countryId: string,
  partner: "gi" | "mmt"
) => {
  try {
    const response = await API_HTTP.get(
      `${CMS_API_BASE_URL}/api/v1/seo/jsons?type=${
        partner === PARTNER.GI
          ? SEO_PAGES_V2_QUERY_ID.LANDING_PAGE_COUNTRY_GI
          : SEO_PAGES_V2_QUERY_ID.LANDING_PAGE_COUNTRY
      },seo-insurance${
        partner === PARTNER.GI ? `-${partner}` : ""
      }-landing-${countryId}`
    );

    return response?.data;
  } catch (error) {
    console.error(`Error fetching data for SEO landing page for ${countryId}`, {
      error,
    });
    throw error;
  }
};
